module.exports = __webpack_public_path__ + "img/btn_arrow_w.4fc9f1a2.svg";